var _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconErase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.71,5.53,10.47,1.29a1,1,0,0,0-1.41,0L1.29,9.06a1,1,0,0,0,0,1.41L2.82,12H4.94L2.71,9.77,4.43,8,8,11.57,7.53,12H9.65l5.06-5.06A1,1,0,0,0,14.71,5.53ZM9,10.51,5.49,7,9.77,2.71l3.52,3.52Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "6.24 15 6.24 15 6.24 15 6.24 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,13.5H3.5A.5.5,0,0,0,3,14v.5a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5V14a.5.5,0,0,0-.5-.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErase);
export default __webpack_public_path__ + "static/media/icon_erase.319c8e8e23bb89805537d4dbb8ed677a.svg";
export { ForwardRef as ReactComponent };